// extracted by mini-css-extract-plugin
export default {"container":"Group_container__a6UMV","title":"Group_title__agKxe","content":"Group_content__afwxp"};